import moment from 'moment';
import { useEffect, useState } from 'react';
import { useConfig } from '../../api/api';
import { useTranslation } from 'react-i18next';

const DateTimeLabel = ({ dateTime, useStrings }) => {
  const config = useConfig();
  const { t } = useTranslation();
  const [dateTimeLabel, setDateTimeLabel] = useState('');
  useEffect(() => {
    if (!config) return;
    if (useStrings) {
      setDateTimeLabel(getDateLabel(dateTime));
    } else {
      const formattedDate = moment(dateTime).format(
        config.general.datetimeOutputFormat
      );

      setDateTimeLabel(formattedDate);
    }
  }, [config, dateTime]);

  function getDateLabel(dateTime) {
    const dateMoment = moment(dateTime);
    const now = moment();

    if (dateMoment.isSame(now, 'day')) {
      return dateMoment.format('HH:mm');
    } else if (dateMoment.isSame(now.clone().subtract(1, 'day'), 'day')) {
      return `${t('yesterday')} ${dateMoment.format('HH:mm')}`;
    } else {
      return dateMoment.format(config.general.dateOutputFormat);
    }
  }

  return <>{dateTimeLabel}</>;
};

export default DateTimeLabel;
